"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  t = require("styled-components"),
  a = require("prop-types"),
  r = require("./assistiveText-80858a8d.js"),
  i = require("./grid-965d799c.js"),
  n = require("./sectionContainer-2a921e1c.js"),
  o = require("./link-8b1ebef7.js"),
  l = require("./taggedTemplateLiteral-97b463ad.js"),
  d = require("polished/lib/helpers/rem"),
  s = require("./typography-fb2881fe.js");
function m(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var u,
  p,
  c,
  f,
  g = m(e),
  h = m(t),
  b = m(a),
  T = m(d),
  k = h["default"](o.LinkComponent)(u || (u = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var a = e.theme.mediumUp();
    return t.css(p || (p = l._taggedTemplateLiteral(["\n      font-size: ", "; /** h3 */\n      line-height: ", "; /** h3 */\n    "])), a ? T["default"](24) : T["default"](19), a ? T["default"](32) : T["default"](25));
  }),
  y = h["default"](s.TypographyComponent)(c || (c = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var a = e.theme,
      r = e.disableBottomPadding,
      i = a.mediumUp() ? T["default"](16) : T["default"](12);
    return r && (i = 0), t.css(f || (f = l._taggedTemplateLiteral(["\n      padding-bottom: ", ";\n      text-align: ", ";\n    "])), i, a.xlargeUp() ? "center" : "left");
  }),
  v = function v(e) {
    var t = e.backgroundVariant,
      a = e.className,
      l = e.disableBottomPadding,
      d = e.moduleName,
      s = e.moduleVariation,
      m = e.sectionId,
      u = e.themeType;
    return g["default"].createElement(n.SectionContainerComponent, {
      backgroundVariant: t,
      className: a,
      disableBottomPadding: l,
      id: m,
      moduleName: d,
      moduleVariation: s,
      themeType: u
    }, g["default"].createElement(r.AssistiveTextComponent, {
      component: "h2"
    }, "Broker-Dealer Disclosure"), g["default"].createElement(i.Row, {
      align: "center"
    }, g["default"].createElement(i.Col, {
      medium: 8
    }, g["default"].createElement(y, {
      themeType: u,
      variant: "h3"
    }, "To learn more about Northwestern Mutual Investment Services, LLC and its financial professionals, visit ", g["default"].createElement(k, {
      isOutgoingLink: !0,
      linkUrl: "https://brokercheck.finra.org/",
      noWrap: !0,
      themeType: u,
      variant: "primaryDeemphasize"
    }, "FINRA BrokerCheck®"), "."), g["default"].createElement(y, {
      disableBottomPadding: !0,
      themeType: u
    }, "Visit our ", g["default"].createElement(o.LinkComponent, {
      linkUrl: "/client-relationship-summary/",
      noWrap: !0,
      themeType: u,
      variant: "primaryDeemphasize"
    }, "Client Relationship Summaries"), " (Form CRS) for information about our firms that provide brokerage and advisory services."))));
  };
v.propTypes = {
  backgroundVariant: b["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  className: b["default"].string,
  disableBottomPadding: b["default"].bool,
  moduleName: b["default"].string,
  moduleVariation: b["default"].string,
  sectionId: b["default"].string.isRequired,
  themeType: b["default"].oneOf(["lightTheme", "darkTheme"])
}, v.defaultProps = {
  backgroundVariant: "lightA",
  disableBottomPadding: !1,
  moduleName: "broker-dealer-disclosure",
  moduleVariation: "A",
  sectionId: "broker-dealer-disclosure",
  themeType: "lightTheme"
};
var C = t.withTheme(v);
exports.BrokerDealerDisclosure = C;